export { ReviewCarousel as default } from "./review-carousel";
export type { ReviewCarouselProps } from "./review-carousel";
